import axios from "axios";
import { USER_URL, RESET_PASSWORD_URL, LOGOUT_USER_URL } from "../../../../../constants/config";

//call api to fetch customers
export function findUsers(queryParams) {
  return axios.get(
    `${USER_URL}/list?search_key=${queryParams?.searchKey || ""}&page=${queryParams?.pageNumber || null}&page_size=${queryParams?.pageSize || null}&assign_customer=${queryParams?.assign_customer || ""}&status=${[1, "1", 0, "0"].includes(queryParams?.status) ? queryParams?.status : ""}`
  );
}

export const findUsersCustomizedWay = (params) => {
  return axios.get(`${USER_URL}/list`, { params });
};
export const findUsersBasic = (params) => {
  return axios.get(`${USER_URL}/list/basic`, { params });
};
export function createUser(user) {
  return axios.post(`${USER_URL}`, user);
}

export function updateUser(user) {
  return axios.patch(`${USER_URL}/${user.id}`, user);
}

export function changeStatus(id, status) {
  return axios.patch(`${USER_URL}/${id}`, {
    status: parseInt(status),
  });
}

export function changePassword(id, queryParams) {
  let params = {
    old_password: queryParams.currentPassword,
    password: queryParams.password,
  };

  if (queryParams.login_pin) {
    params.login_pin = queryParams.login_pin;
    params.old_password = queryParams.currentPassword;
    delete params.password; 

  }
  return axios.patch(`${USER_URL}/${id}`, { ...params });
}


export function resetPassword(params) {
  return axios.post(`${RESET_PASSWORD_URL}/url`, params);
}

export function generateResetPassword(params) {
  return axios.post(`${RESET_PASSWORD_URL}`, params);
}

export function getSingleUser(id) {
  return axios.get(`${USER_URL}/${id}`);
}

export function changeUserPassword(id,payload) {
  return axios.patch(`${USER_URL}/${id}/change_password`, { ...payload });
};
export function changeUserPin(id,payload) {
  return axios.patch(`${USER_URL}/${id}/change_login_pin`, { ...payload });
};


export function logOutUser(){
  return axios.post(`${LOGOUT_USER_URL}`)
}

// toggle chat/message access for a user
export function toggleUserAccess(id, payload) {
  return axios.patch(`${USER_URL}/${id}`, { ...payload });
}